
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/risk-disclosure",
      function () {
        return require("private-next-pages/risk-disclosure.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/risk-disclosure"])
      });
    }
  